import { Component } from '@angular/core';
import { GuestUserService } from '../guest-user.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GuestUser } from 'src/app/shared/model/guest-user.model';

@Component({
  selector: 'app-guestuser',
  templateUrl: './guestuser.component.html',
  styleUrls: ['./guestuser.component.scss']
})
export class GuestuserComponent {
  countryData: any[] = [];
  stateData: any[] = [];
  cityData: any[] = [];
  logoToUpload: any;
  guestuser: GuestUser = new GuestUser();
  companyId!: number;
  role: any;
  readable: boolean = false;


  constructor(
    private guestUserService: GuestUserService,
    private toastr: ToastrService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private http: HttpClient
  ) {
    this.activeRoute.queryParamMap.subscribe((param: any) => {
      this.companyId = param.params.company_id
      this.role = param.params.role;
      if (this.role == 'view') {
        this.readable = true;
      } else {
        this.readable = false;
      }
    });
  }

  ngOnInit(): void {
    const storedData = localStorage.getItem('companyDetails');
    this.getAllCountry();
    if (this.companyId != null || undefined) {
      this.getCompanyById();
    } else {
      if (storedData !== null) {
        this.guestuser = JSON.parse(storedData);
        this.countrySelect(this.guestuser.country_id)
        this.stateSelect(this.guestuser.state_id)
      }
    }
  }

  getCompanyById() {
    this.guestUserService.getCompanyById(this.companyId).subscribe((res: any) => {
      console.log(res);
      if (res && res.body) {
        this.guestuser = res.body.data;
        this.logoToUpload = this.guestuser.logo
        console.log(this.guestuser.logo)
        this.guestuser.logo = ''
        this.guestuser.confirm_password = this.guestuser.password;
        this.countrySelect(this.guestuser.country_id)
        this.stateSelect(this.guestuser.state_id)
      }
    })
  }

  getAllCountry() {
    this.guestUserService.getAllCountry().subscribe((res: any) => {
      console.log(res);
      if (res && res.body) {
        this.countryData = res.body.data;
      }

    })
  }

  submit() {
    localStorage.removeItem('companyDetails')
    console.log(this.guestuser);

    console.log('this.compantDetails.logo-->', this.guestuser.logo)
    if (this.guestuser.password != this.guestuser.confirm_password) {
      this.toastr.error('Password and confirm Password should be same');
      return;
    };
    this.guestuser.empType = 'guestUser';
      this.guestUserService.createGuestUser(this.guestuser).subscribe((res: any) => {
        if (res && res.body) {
          localStorage.setItem('companyDetails', JSON.stringify(this.guestuser));
          localStorage.setItem('employeeId', JSON.stringify(res.body.employeeId));
          this.toastr.success(res.body.message);
          this.router.navigate(['login/guestuser/configuration'], { queryParams: { company_id: res.body.data.company_id }, });
          this.cleanInput();
        }
      })
  }


  previousState() {
    window.history.back();
  }

  countrySelect(event: any) {
    console.log(event,);
    let countryId = event
    this.guestUserService.getStateByCountryId(countryId).subscribe(res => {
      if (res && res.body) {
        this.stateData = res.body.data
      }
    })
  }

  stateSelect(event: any) {
    console.log(event,);
    let stateId = event
    this.guestUserService.getCityByStateId(stateId).subscribe(res => {
      if (res && res.body) {
        this.cityData = res.body.data
      }
    })
  }

  onFileSelected(event: any): void {
    const fileInput: HTMLInputElement = event.target;
    const files: FileList | null = fileInput.files; // Use FileList | null
    if (files && files.length > 0) {
      const file: File = files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        console.log(e.target.result)
        this.guestuser.logo = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  downloadFile() {
    // Replace 'your_file_endpoint' with the actual API endpoint that serves the file
    const fileEndpoint = this.logoToUpload || '';

    // Trigger the server to set the Content-Disposition header for download
    this.http
      .get(fileEndpoint, {
        responseType: 'blob', // Receive the response as a blob
      })
      .subscribe((blob) => {
        // Create a temporary link and trigger the download
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'logo.png'; // Specify the desired filename for the downloaded file
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });
  }

  // navigateToNext() {
  //   this.router.navigate(['/configuration'], { queryParams: { company_id: this.companyId } });
  // }
  cleanInput() {
    this.guestuser.user_name = '';
    this.guestuser.password = '';
  }
}
